module.exports = __webpack_public_path__ + "media/images/icon__teaserSampleBetInfo@3x-74cf75700954f38548bd73f74ae43a95.png";